export const hasWindow = () => typeof window !== 'undefined';
export const handleKeyPress = (event, key, callbackFn) => {
    if (event.key === key) {
        callbackFn();
    }
};
